export enum EAuthCookieName {
  refreshJwt = 'refresh_token',
  jwt = 'access_token',
}
